// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   ForgotPassword 2026 — Figma node 2045:12569 기반 신규 디자인
   모바일 360px 단일 컬럼, signup2026 시스템과 동일한 토큰 사용
   ============================================================ */

.forgot2026 {
    min-height: 100vh;
    background: #fff;
    font-family: var(--font-sans, 'Pretendard', sans-serif);
    color: var(--fg-text-basic);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px 24px 32px;
    box-sizing: border-box;
}

.forgot2026__main {
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 24px;
    flex: 1 1;
}

.forgot2026__form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

/* ─── 브랜드 ─── */
.forgot2026__brand {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 42px;
}

.forgot2026__brand-logo {
    width: 38px;
    height: 42px;
    object-fit: contain;
    display: block;
}

.forgot2026__brand-text {
    font-family: 'Pretendard', sans-serif;
    font-size: 26px;
    font-weight: 800;
    color: var(--fg-text-basic);
    letter-spacing: -0.6px;
    line-height: 1;
}

/* ─── 섹션 ─── */
.forgot2026__section {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.forgot2026__section--done {
    align-items: center;
    text-align: center;
}

/* ─── 타이틀 / 설명 ─── */
.forgot2026__title {
    margin: 0;
    font-size: 28px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: -0.2px;
    color: var(--fg-text-basic);
}

.forgot2026__desc {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: var(--fg-text-gray);
}

/* ─── 필드 ─── */
.forgot2026__field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
}

.forgot2026__field-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    color: var(--fg-text-basic);
}

.forgot2026__field-label svg {
    flex-shrink: 0;
}

.forgot2026__input {
    width: 100%;
    box-sizing: border-box;
    padding: 12px;
    background: #fff;
    border: 1px solid var(--fg-line);
    border-radius: 8px;
    font-family: inherit;
    font-size: 16px;
    line-height: 24px;
    color: var(--fg-text-basic);
    outline: none;
    transition: border-color 160ms ease;
}

.forgot2026__input::placeholder {
    color: var(--fg-text-gray);
}

.forgot2026__input:focus {
    border-color: var(--fg-button);
}

.forgot2026__input:disabled {
    background: #fafafa;
    color: var(--fg-text-gray);
    cursor: not-allowed;
}

.forgot2026__input--error {
    border-color: var(--fg-anti-red, #ff1500);
}

.forgot2026__input--has-toggle {
    padding-right: 44px;
}

.forgot2026__field-error {
    margin: 0;
    font-size: 14px;
    line-height: 1.2;
    color: var(--fg-anti-red, #ff1500);
}

.forgot2026__field-hint {
    margin: 0;
    font-size: 13px;
    line-height: 1.2;
    color: var(--fg-text-gray);
}

.forgot2026__form-error {
    margin: 4px 0 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    text-align: center;
    color: var(--fg-anti-red, #ff1500);
    white-space: pre-line;
}

/* ─── 비밀번호 토글 ─── */
.forgot2026__pw-wrap {
    position: relative;
    width: 100%;
}

.forgot2026__pw-toggle {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    background: transparent;
    border: 0;
    color: var(--fg-text-gray);
    cursor: pointer;
    transition: color 160ms ease;
}

.forgot2026__pw-toggle:hover {
    color: var(--fg-text-basic);
}

/* ─── 버튼 ─── */
.forgot2026__submit {
    width: 100%;
    min-height: 44px;
    padding: 12px;
    background: var(--fg-button);
    border: 0;
    border-radius: 8px;
    color: #fff;
    font-family: inherit;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    transition: background 160ms ease;
}

.forgot2026__submit:hover:not(:disabled) {
    background: var(--fg-button-hover);
}

.forgot2026__submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.forgot2026__submit--link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    text-align: center;
    width: 100%;
    box-sizing: border-box;
}

/* ─── 하단 링크 ─── */
.forgot2026__bottom-link {
    margin: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 14px;
    line-height: 1.4;
    color: var(--fg-text-basic);
    text-align: center;
    flex-wrap: wrap;
}

.forgot2026__bottom-link a,
.forgot2026__link-btn {
    color: var(--fg-link, #2c95f8);
    text-decoration: underline;
    font-weight: 600;
    background: transparent;
    border: 0;
    padding: 0;
    font-family: inherit;
    font-size: 14px;
    cursor: pointer;
    transition: color 160ms ease;
}

.forgot2026__bottom-link a:hover,
.forgot2026__link-btn:hover:not(:disabled) {
    color: var(--fg-link-hover, #1a7ad6);
}

.forgot2026__link-btn--disabled,
.forgot2026__link-btn:disabled {
    color: var(--fg-text-gray);
    cursor: not-allowed;
    text-decoration: none;
}

/* ─── 성공 단계 ─── */
.forgot2026__success-circle {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: var(--fg-button);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0;
}

`, "",{"version":3,"sources":["webpack://./src/css/ForgotPassword.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uDAAuD;IACvD,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,gBAAgB;AAChB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,sBAAsB;IACtB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,mCAAmC;AACvC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,SAAS;IACT,0BAA0B;IAC1B,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,eAAe;AACf;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;AAC1B;;AAEA,kBAAkB;AAClB;IACI,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,8BAA8B;IAC9B,0BAA0B;IAC1B,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,4BAA4B;AAChC;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,0BAA0B;IAC1B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB","sourcesContent":["/* ============================================================\n   ForgotPassword 2026 — Figma node 2045:12569 기반 신규 디자인\n   모바일 360px 단일 컬럼, signup2026 시스템과 동일한 토큰 사용\n   ============================================================ */\n\n.forgot2026 {\n    min-height: 100vh;\n    background: #fff;\n    font-family: var(--font-sans, 'Pretendard', sans-serif);\n    color: var(--fg-text-basic);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 48px 24px 32px;\n    box-sizing: border-box;\n}\n\n.forgot2026__main {\n    width: 100%;\n    max-width: 360px;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 24px;\n    flex: 1;\n}\n\n.forgot2026__form {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n/* ─── 브랜드 ─── */\n.forgot2026__brand {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    height: 42px;\n}\n\n.forgot2026__brand-logo {\n    width: 38px;\n    height: 42px;\n    object-fit: contain;\n    display: block;\n}\n\n.forgot2026__brand-text {\n    font-family: 'Pretendard', sans-serif;\n    font-size: 26px;\n    font-weight: 800;\n    color: var(--fg-text-basic);\n    letter-spacing: -0.6px;\n    line-height: 1;\n}\n\n/* ─── 섹션 ─── */\n.forgot2026__section {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n}\n\n.forgot2026__section--done {\n    align-items: center;\n    text-align: center;\n}\n\n/* ─── 타이틀 / 설명 ─── */\n.forgot2026__title {\n    margin: 0;\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 40px;\n    letter-spacing: -0.2px;\n    color: var(--fg-text-basic);\n}\n\n.forgot2026__desc {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: var(--fg-text-gray);\n}\n\n/* ─── 필드 ─── */\n.forgot2026__field {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    width: 100%;\n}\n\n.forgot2026__field-label {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1;\n    color: var(--fg-text-basic);\n}\n\n.forgot2026__field-label svg {\n    flex-shrink: 0;\n}\n\n.forgot2026__input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 12px;\n    background: #fff;\n    border: 1px solid var(--fg-line);\n    border-radius: 8px;\n    font-family: inherit;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--fg-text-basic);\n    outline: none;\n    transition: border-color 160ms ease;\n}\n\n.forgot2026__input::placeholder {\n    color: var(--fg-text-gray);\n}\n\n.forgot2026__input:focus {\n    border-color: var(--fg-button);\n}\n\n.forgot2026__input:disabled {\n    background: #fafafa;\n    color: var(--fg-text-gray);\n    cursor: not-allowed;\n}\n\n.forgot2026__input--error {\n    border-color: var(--fg-anti-red, #ff1500);\n}\n\n.forgot2026__input--has-toggle {\n    padding-right: 44px;\n}\n\n.forgot2026__field-error {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.2;\n    color: var(--fg-anti-red, #ff1500);\n}\n\n.forgot2026__field-hint {\n    margin: 0;\n    font-size: 13px;\n    line-height: 1.2;\n    color: var(--fg-text-gray);\n}\n\n.forgot2026__form-error {\n    margin: 4px 0 0;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: center;\n    color: var(--fg-anti-red, #ff1500);\n    white-space: pre-line;\n}\n\n/* ─── 비밀번호 토글 ─── */\n.forgot2026__pw-wrap {\n    position: relative;\n    width: 100%;\n}\n\n.forgot2026__pw-toggle {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    padding: 0;\n    background: transparent;\n    border: 0;\n    color: var(--fg-text-gray);\n    cursor: pointer;\n    transition: color 160ms ease;\n}\n\n.forgot2026__pw-toggle:hover {\n    color: var(--fg-text-basic);\n}\n\n/* ─── 버튼 ─── */\n.forgot2026__submit {\n    width: 100%;\n    min-height: 44px;\n    padding: 12px;\n    background: var(--fg-button);\n    border: 0;\n    border-radius: 8px;\n    color: #fff;\n    font-family: inherit;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 160ms ease;\n}\n\n.forgot2026__submit:hover:not(:disabled) {\n    background: var(--fg-button-hover);\n}\n\n.forgot2026__submit:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.forgot2026__submit--link {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    text-align: center;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* ─── 하단 링크 ─── */\n.forgot2026__bottom-link {\n    margin: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    font-size: 14px;\n    line-height: 1.4;\n    color: var(--fg-text-basic);\n    text-align: center;\n    flex-wrap: wrap;\n}\n\n.forgot2026__bottom-link a,\n.forgot2026__link-btn {\n    color: var(--fg-link, #2c95f8);\n    text-decoration: underline;\n    font-weight: 600;\n    background: transparent;\n    border: 0;\n    padding: 0;\n    font-family: inherit;\n    font-size: 14px;\n    cursor: pointer;\n    transition: color 160ms ease;\n}\n\n.forgot2026__bottom-link a:hover,\n.forgot2026__link-btn:hover:not(:disabled) {\n    color: var(--fg-link-hover, #1a7ad6);\n}\n\n.forgot2026__link-btn--disabled,\n.forgot2026__link-btn:disabled {\n    color: var(--fg-text-gray);\n    cursor: not-allowed;\n    text-decoration: none;\n}\n\n/* ─── 성공 단계 ─── */\n.forgot2026__success-circle {\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    background: var(--fg-button);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin: 8px 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
